import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Subject } from 'rxjs';
import { UsedSgkc012aService } from '../../services/used-sgkc012a.service';
import { takeUntil } from 'rxjs/operators';
import { Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto, Sgkc012aRequest, Sgkc016aReqSlideadjustmentunitpriceApprvInfoDto, Sgkc016aRequest, Sgkc019aReqSlideadjustmentunitpriceRegInfoDto, Sgkc019aRequest, Sgkc028aReqSlideadjustmentunitpriceCancelInfoDto, Sgkc028aRequest, SlideadjustmentunitpriceBasicInfo, SlideadjustmentunitpriceInfo, SlidecalculationDetailsinformationDto } from 'sg-api';
import { DisplayMode } from 'cbc-shared-lib';
import { UsedSgkc019aService } from '../../services/used-sgkc019a.service';
import { UsedSgkc028aService } from '../../services/used-sgkc028a.service';
import { UsedSgkc016aService } from '../../services/used-sgkc016a.service';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';

/**
 * スライド調整単価登録画面(単価情報)
 * @exports
 * @class Sgkc032dComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc032d',
    templateUrl: './sgkc032d.component.html',
    styleUrl: './sgkc032d.component.scss'
})
export class Sgkc032dComponent implements OnInit, OnDestroy {
    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** 画面表示モード */
    displayMode: string;
    /** スライド調整単価コード */
    slideadjustmentunitpriceCode: string;
    /** 適用開始年月 */
    applyStartyearmonth: string;
    /** 適用開始日付 */
    applyStartDate: string;
    /** スライド調整単価基本情報 */
    slideadjustmentunitpriceBasicInfo: SlideadjustmentunitpriceBasicInfo;
    /** スライド調整単価情報 */
    slideadjustmentunitpriceInfo: SlideadjustmentunitpriceInfo;
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** 子コンポーネントの入力内容受取Form */
    slideTankatableDetailForm: UntypedFormGroup;
    /** 詳細表示フラグ */
    showDetailflag: boolean = false;

    /** 
     * コンストラクタ
     * @param {Router} router  - ルーター
     * @param {UntypedFormBuilder} fb - フォームビルダー
     * @param {ActivatedRoute} route - ルート情報
     * @param {UsedSgkc012aService} usedSgkc012aService - スライド調整単価詳細取得サービス
     * @param {UsedSgkc019aService} usedSgkc019aService - スライド調整単価登録サービス
     * @param {UsedSgkc028aService} usedSgkc028aService - スライド調整単価取消サービス
     * @param {UsedSgkc016aService} usedSgkc016aService - スライド調整単価承認サービス
     * @param {CompleteDataService} completeDataService - 完了データサービス
     * @memberof Sgkc032dComponent
     */
    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private route: ActivatedRoute,
        private usedSgkc012aService: UsedSgkc012aService,
        private usedSgkc019aService: UsedSgkc019aService,
        private usedSgkc028aService: UsedSgkc028aService,
        private usedSgkc016aService: UsedSgkc016aService,
        private completeDataService: CompleteDataService,
    ) {
        this.slideTankatableDetailForm = this.fb.group({});
    }

    /** 
     * 初期処理
     * @memberof Sgkc032dComponent
     */
    ngOnInit(): void {
        // 画面モードを取得
        this.displayMode = this.route.snapshot.paramMap.get('mode');
        // スライド調整単価コードを取得
        this.slideadjustmentunitpriceCode = this.route.snapshot.paramMap.get('slideadjustmentunitpriceCode');
        // 適用開始年月
        this.applyStartyearmonth = this.route.snapshot.paramMap.get('applyStartyearmonth');
        // 適用開始日付
        this.applyStartDate = this.route.snapshot.paramMap.get('applyStartDate');
        // 受信データの購読設定（単価マスタ詳細）
        this.usedSgkc012aService.slideTankatableChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
                this.slideadjustmentunitpriceBasicInfo = response.slideadjustmentunitpriceBasicInfo;
                this.slideadjustmentunitpriceInfo = response.slideadjustmentunitpriceInfo;
            });

        // スライド調整単価詳細取得APIのリクエストを作成
        let sgkc012aRequest: Sgkc012aRequest;
        let slideadjustmentunitpriceShutokuinfo: Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto;
        // 画面モード承認、参照時
        if (this.displayMode === DisplayMode.approve || this.displayMode === DisplayMode.read) {
            slideadjustmentunitpriceShutokuinfo = {
                slideadjustmentunitpriceCode: this.slideadjustmentunitpriceCode,
                applyStartyearmonth: this.applyStartyearmonth,
                applyStartDate: this.applyStartDate
            }
            sgkc012aRequest = {
                slideadjustmentunitpriceShutokuinfo: slideadjustmentunitpriceShutokuinfo
            }
        } else {
            slideadjustmentunitpriceShutokuinfo = {
                slideadjustmentunitpriceCode: this.slideadjustmentunitpriceCode,
                applyStartyearmonth: null,
                applyStartDate: null
            }
            sgkc012aRequest = {
                slideadjustmentunitpriceShutokuinfo: slideadjustmentunitpriceShutokuinfo
            }
        }
        // スライド調整単価詳細取得APIを呼び出し
        this.usedSgkc012aService.getSlideTankatableDetails(sgkc012aRequest)
            .subscribe(response => {
                this.showDetailflag = true;
            }, error => {
            });
    }

    /** 
    * 購読を停止する処理
    * @memberof Sgkc032dComponent
    */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** 
    * 登録ボタン押下時処理
    * @memberof Sgkc032dComponent
    */
    onClickRegistration(): void {
        // リクエストを作成する
        const form = this.slideTankatableDetailForm.getRawValue().slideTankaRegisterInfoForm;
        // 格納用スライド算定諸元登録情報リスト
        const slidecalculationelementsRegInformationlist: SlidecalculationDetailsinformationDto[] =
            form.items.map(dto => ({
                slidecalculationDetailscode: dto.slidecalculationelementsCode,
                slidecalculationDetailsinformation: dto.slidecalculationelementsInfo,
            })
            )

        const slideadjustmentunitpriceRegInfo: Sgkc019aReqSlideadjustmentunitpriceRegInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyStartyearmonth,
            applyEndyearmonth: form.applyEndyearmonth,
            applyStartDate: form.applyStartDate,
            applyEndDate: form.applyEndDate,
            slideadjustmentunitprice: !isNaN(Number(form.slideadjustmentunitprice)) ? Number(form.slideadjustmentunitprice) : null,
            slidecalculationelementsRegInformationlist: slidecalculationelementsRegInformationlist,
        }
        const sgkc019aRequest: Sgkc019aRequest = {
            slideadjustmentunitpriceRegInfo: slideadjustmentunitpriceRegInfo
        }
        this.usedSgkc019aService.registSlideTankatable(sgkc019aRequest)
            .subscribe(response => {
                if (response) {
                    // 登録完了画面遷移
                    this.completeDataService.completeData = {
                        title: 'スライド調整単価登録完了',       // 画面タイトルを設定
                        message: 'スライド調整単価を登録しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc031d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 取消ボタン押下時処理
    * @memberof Sgkc032dComponent
    */
    onClickDelete(): void {
        // リクエストを作成する
        const form = this.slideTankatableDetailForm.getRawValue().slideTankaRegisterInfoForm;
        const slideadjustmentunitpriceCancelInfo: Sgkc028aReqSlideadjustmentunitpriceCancelInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyStartyearmonth,
            applyStartDate: form.applyStartDate,
            updateSrno: this.slideadjustmentunitpriceInfo.updateSrno
        }
        const sgkc028aRequest: Sgkc028aRequest = {
            slideadjustmentunitpriceCancelInfo: slideadjustmentunitpriceCancelInfo
        }
        this.usedSgkc028aService.deleteSlideTankatable(sgkc028aRequest)
            .subscribe(response => {
                if (response) {
                    // 取消完了画面遷移
                    this.completeDataService.completeData = {
                        title: 'スライド調整単価取消完了',       // 画面タイトルを設定
                        message: 'スライド調整単価を取消しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc031d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 承認ボタン押下時処理
    * @memberof Sgkc032dComponent
    */
    onClickApproval(): void {
        // リクエストを作成する
        const form = this.slideTankatableDetailForm.getRawValue().slideTankaRegisterInfoForm;
        const slideadjustmentunitpriceApprvInfo: Sgkc016aReqSlideadjustmentunitpriceApprvInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyStartyearmonth,
            applyStartDate: form.applyStartDate,
            updateSrno: this.slideadjustmentunitpriceInfo.updateSrno
        }
        const sgkc016aRequest: Sgkc016aRequest = {
            slideadjustmentunitpriceApprvInfo: slideadjustmentunitpriceApprvInfo
        }
        this.usedSgkc016aService.approveSlideTankatable(sgkc016aRequest)
            .subscribe(response => {
                if (response) {
                    // 承認完了画面遷移
                    this.completeDataService.completeData = {
                        title: 'スライド調整単価承認完了',       // 画面タイトルを設定
                        message: 'スライド調整単価を承認しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc031d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }
}
